import React, { useEffect, useMemo, useState } from "react";
import { TOTAL_CLAIM_BALANCE_NO_PAID } from "../../../graphql/orderGroup/query";
import { useLazyQuery } from "@apollo/client";
import {
    MdFingerprint,
    MdDoNotDisturbOn,
    MdError,
    MdDoDisturbOff,
    MdCheckCircle,
    MdCloudDone,
    MdDoneAll,
} from "react-icons/md";
import _ from "lodash";
import moment from "moment";
import { numberFormat } from "../../../helpers";

const keyLocalStorage = "CLAIM_BALANCE_REPORT::";

function BtnClaimBalanceReport({
    cdFillter,
    listpage,
    setlistpage,
    isClaimBalance,
    setIsClaimBalance,
    isFetch,
    start,
    end,
    type,
    total
}) {
    //TODO CALL API CLAIM BALANCE
    const [loading, setLoading] = useState(false);

    // TODO useState total
    const [invalidPaid, setInvalidPaid] = useState(0);
    const [noPaid, setNoPaid] = useState(0);
    const [noticeNoPaid, setNoticeNoPaid] = useState(0);
    const [waitingConfirm, setWaitingConfirm] = useState(0);
    const [claimBalance, setClaimBalance] = useState(0);
    const [notClaimBalance, setNotClaimBalance] = useState(0);
    const [printOrder, setPrintOrder] = useState(0);
    const [userConfirm, setUserConfirm] = useState(0);
    const [completedCount, setCompletedCount] = useState(0);
    const [checkDate, setCheckDate] = useState(false);
    const [checkType, setCheckType] = useState(false);
    const [localData, setLocalData] = useState(null);


    //TODO LOCAL STORAGE
    const getLocalStorage = () => {
        let SHOP_ID = localStorage.getItem("SHOP");
        const newKey = `${keyLocalStorage}SHOP::${SHOP_ID}`; //`${keyLocalStorage}START::${start}::END${end}::TYPE::${type}`
        const data = getItemClaimBalanceReport({ key: newKey });
        return data;
    };
    const setLocalStorage = (data) => {
        let SHOP_ID = localStorage.getItem("SHOP");
        const newKey = `${keyLocalStorage}SHOP::${SHOP_ID}`; //`${keyLocalStorage}START::${start}::END${end}::TYPE::${type}`
        // setItemClaimBalanceReport({
        //     key: newKey,
        //     value: data,
        //     // expireTime: 60,
        // });
        // setTimeout(() => {
        //     return;
        // }, 100);
    };

    //TODO GQL
    const [
        getTotalOrderGroupClaimBalance,
        {
            data: totalOrderGroupClaimBalance,
            loading: totalOrderGroupClaimBalanceLoading,
        },
    ] = useLazyQuery(TOTAL_CLAIM_BALANCE_NO_PAID, { fetchPolicy: "network-only" });

    useEffect(() => {
        // const result = getLocalStorage();
        // if (result) {
        //     setLocalData(result);
        // } else {
        //     if (totalOrderGroupClaimBalanceLoading) return;
        //     getClaimBalanceFromAPI();
        // }
        if (totalOrderGroupClaimBalanceLoading) return;
        getClaimBalanceFromAPI();
    }, [checkDate, cdFillter, type, total]);

    useEffect(() => {
        setCheckDate(true);
        // getClaimBalanceFromAPI();
    }, [start, end]);

    useEffect(() => {
        setCheckType(true);
    }, [type]);

    //TODO Set total
    useEffect(() => {
        // if (localData) {
        //     // console.log("data from local");
        //     setNoPaid(localData?.no_paid?.total);
        //     setInvalidPaid(localData?.invalidPaid?.total);
        //     setNoticeNoPaid(localData?.noticeNoPaid?.total);
        //     setWaitingConfirm(localData?.waitingConfirm?.total);
        //     setClaimBalance(localData?.claimBalance?.total);
        //     setPrintOrder(localData?.printOrder?.total);
        //     setUserConfirm(localData?.userConfirm?.total);
        // } else 

        if (totalOrderGroupClaimBalance) {
            // console.log("data from api");
            setNoPaid(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.no_paid?.total
            );
            setInvalidPaid(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.invalidPaid
                    ?.total
            );
            setNoticeNoPaid(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.noticeNoPaid
                    ?.total
            );
            setWaitingConfirm(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.waitingConfirm
                    ?.total
            );
            setClaimBalance(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.claimBalance
                    ?.total
            );
            setNotClaimBalance(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.notClaimBalance
                    ?.total
            );
            setPrintOrder(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.printOrder
                    ?.total
            );
            setUserConfirm(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.userConfirm
                    ?.total
            );

            setCompletedCount(
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.completed?.total ??
                total?.COMPLETED ??
                total?.completed ??
                totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance?.userConfirm?.total ??
                0
            );

            //TODO set local storage
            // setLocalStorage(totalOrderGroupClaimBalance?.totalOrderGroupClaimBalance);
        }
    }, [totalOrderGroupClaimBalance]);

    const getClaimBalanceFromAPI = async () => {
        try {
            setLoading(true);
            let SHOP_ID = await localStorage.getItem("SHOP");
            let _where = {
                shop: SHOP_ID,
            };

            if (!_.isEmpty(cdFillter)) {
                const splitDateTime = (dateString) => {
                    const date = new Date(dateString);
                    const datePart = date.toISOString().split('T')[0];
                    const timePart = date.toISOString().split('T')[1].split('.')[0];
                    return datePart;
                };

                let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
                let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);

                _where = {
                    ..._where,
                    start: startDateComponents,
                    end: endDateComponents,
                };
            }
            if (checkType) {
                _where = {
                    ..._where,
                    type: type,
                };
            }
            const _orderGroupData = await getTotalOrderGroupClaimBalance({
                variables: {
                    where: _where,
                },
            });
        } catch (error) {
            console.log("get order group total claim balance error: ", error);
        }
    };
    // ທຸກໃບໜ້າຕາຄືກັນໝົດ ຕ່າງແຕ່ຂໍ້ມູນ — ຂຽນເປັນ list ຈຶ່ງບໍ່ຕ້ອງ copy JSX ຊ້ຳ 6 ເທື່ອ
    // ສີຮັກສາຂອງເກົ່າໄວ້ ຄົນໃຊ້ຈຳສີໄດ້ຢູ່ແລ້ວ ບໍ່ຕ້ອງມາຮຽນໃໝ່
    const statusTiles = [
        { key: "PAYMENT_STILL_INCOMPLETE", tone: "warning", Icon: MdDoNotDisturbOn, label: "ຍອດເງີນບໍ່ຖືກຕ້ອງ", count: invalidPaid },
        { key: "CREATED", tone: "danger", Icon: MdDoDisturbOff, label: "ອໍເດີ້ເຂົ້າ", count: noPaid },
        { key: "IMAGE_NOT_YET_PAID", tone: "danger", Icon: MdError, label: "ແຈ້ງຍອດແຕ່ບໍ່ໂອນ", count: noticeNoPaid },
        { key: "WAITINGCONFIRM", tone: "warning", Icon: MdFingerprint, label: "ລໍຖ້າການຢືນຢັນ", count: waitingConfirm },
        { key: "USERCONFIRM", tone: "primary", Icon: MdCheckCircle, label: "ກວດສອບແລ້ວ", count: userConfirm },
        { key: "COMPLETED", tone: "success", Icon: MdCheckCircle, label: "ອໍເດີສຳເລັດ", count: completedCount },
    ];

    const renderTile = ({ key, tone, Icon, label, count }) => (
        <button
            key={key}
            type="button"
            // aria-pressed ບອກ screen reader ວ່າໃບນີ້ຖືກເລືອກຢູ່ ສີຢ່າງດຽວບອກບໍ່ໄດ້
            aria-pressed={listpage === key}
            className={`stat-tile stat-tile--${tone}${listpage === key ? " is-active" : ""}`}
            onClick={() => setlistpage(key)}
        >
            <span className="stat-tile__head">
                <Icon aria-hidden="true" /> {label}
            </span>
            <span className="stat-tile__value">{numberFormat(count ?? 0)}</span>
        </button>
    );

    return (
        <div className="box-status-report">
            {statusTiles.slice(0, 4).map(renderTile)}

            {/* ໃບນີ້ໂຄງສ້າງບໍ່ຄືໃບອື່ນ: ຫົວດຽວ ແຕ່ມີສອງຕົວເລກໃຫ້ກົດ */}
            <div className="stat-tile stat-tile--info stat-tile--split">
                <span className="stat-tile__head">
                    <MdDoneAll aria-hidden="true" /> ລາຍການທວງຍອດ
                </span>
                <span className="stat-seg-group">
                    <button
                        type="button"
                        aria-label={`ທວງຍອດແລ້ວ ${claimBalance ?? 0}`}
                        aria-pressed={isClaimBalance === "true"}
                        className={`stat-seg stat-seg--yes${isClaimBalance === "true" ? " is-active" : ""}`}
                        onClick={() => {
                            setlistpage("");
                            setIsClaimBalance("true");
                        }}
                    >
                        {numberFormat(claimBalance ?? 0)}
                    </button>
                    <button
                        type="button"
                        aria-label={`ຍັງບໍ່ທວງຍອດ ${notClaimBalance ?? 0}`}
                        aria-pressed={isClaimBalance === "false"}
                        className={`stat-seg stat-seg--no${isClaimBalance === "false" ? " is-active" : ""}`}
                        onClick={() => {
                            setlistpage("");
                            setIsClaimBalance("false");
                        }}
                    >
                        {numberFormat(notClaimBalance ?? 0)}
                    </button>
                </span>
            </div>

            {statusTiles.slice(4).map(renderTile)}
        </div>
    );
}

//TODO GET LOCAL STORAGE

// Function to get data from localStorage using the key
function getItemClaimBalanceReport({ key }) {
    try {
        const item = window.localStorage.getItem(key);
        if (!item) {
            // console.log("No data found for key:", key);
            return null;
        }

        const result = JSON.parse(item);
        const { expireTime, data } = result;

        // console.log("Local data:", result);

        // console.log("expireTime < Date.now() ", expireTime, Date.now(), expireTime < Date.now());
        // Check if the data has expired
        if (expireTime < Date.now()) {
            window.localStorage.removeItem(key);
            // console.log("Data has expired, removing item.");
            return null;
        }

        // Return the data if not expired
        // console.log("Data:", data);
        return data;
    } catch (error) {
        // console.error("Error parsing localStorage item:", error);
        return null;
    }
}

/**
 * Accepts the key, value, and expiry time as parameters.
 * Default expiry time is 5 minutes (300,000 milliseconds).
 * @param {string} key - The key under which the data will be stored.
 * @param {any} value - The value to store.
 * @param {number} [expireTime=300000] - The expiry time in milliseconds.
 */
function setItemClaimBalanceReport({ key, value, expireTime }) {
    const result = {
        data: value,
        expireTime: Date.now() + expireTime,
    };

    window.localStorage.setItem(key, JSON.stringify(result));
}

export default BtnClaimBalanceReport;
